import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileData: null,
  loading: false,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    fetchProfileStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchProfileSuccess: (state, action) => {
      state.loading = false;
      state.profileData = action.payload;
      state.error = null;
    },
    fetchProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateProfileStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateProfileSuccess: (state, action) => {
      state.loading = false;
      state.profileData = { ...state.profileData, ...action.payload };
      state.error = null;
    },
    updateProfileFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearProfile: (state) => {
      state.profileData = null;
      state.loading = false;
      state.error = null;
    },
    dismissProfileRoleReview: (state) => {
      if (state.profileData) {
        if (state.profileData.profile) {
          state.profileData.profile.pendingRoleReview = false;
        }
        if (state.profileData.professional) {
          state.profileData.professional.pendingRoleReview = false;
        }
        state.profileData.pendingRoleReview = false;
      }
    },
  },
});

export const {
  fetchProfileStart,
  fetchProfileSuccess,
  fetchProfileFailure,
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
  clearProfile,
  dismissProfileRoleReview,
} = profileSlice.actions;

export default profileSlice.reducer;
